import React from "react";
import { Link } from "react-router-dom";

const FooterThree = () => {
  return (
    <footer>
      <div className="footer-area-two footer-area-three">
        <div className="container">
          <div className="footer-top-two">
            <div className="row justify-content-center">
              <div className="col-xl-6 col-lg-8">
                <div className="footer-content-two text-center">
                  <div className="logo">
                    <Link to="/">
                      <img src="/img/logo/logo.png" alt="Vernu Stoffering logo" />
                    </Link>
                  </div>
                  <p>
                    Vernu Stoffering in Rotterdam biedt vakkundige
                    herstellingen en aanpassingen van stoelen, fauteuils en banken. De Snelste en meest Betrouwbare Stoffeerderij met oog voor detail.
                  </p>
                </div>
                <div className="footer-social-links about-social">
                  <a
                    href="https://www.instagram.com/diana.meubelstofferen"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                  
                  <a
                    href="https://www.tiktok.com/@diana.meubelstofferen"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="TikTok"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 48 48"
                      fill="currentColor"
                    >
                      <path d="M41.6 15.9c-4 0-7.3-2.8-8.1-6.5l-0.3-1.4h-5.8v23.9c0 2.4-1.9 4.3-4.3 4.3s-4.3-1.9-4.3-4.3c0-2.4 1.9-4.3 4.3-4.3 0.7 0 1.3 0.2 1.9 0.5v-6.3c-0.6-0.1-1.2-0.1-1.9-0.1-5.9 0-10.6 4.8-10.6 10.6 0 5.9 4.8 10.6 10.6 10.6 5.9 0 10.6-4.8 10.6-10.6v-12.2c2.3 1.5 5.1 2.3 8.1 2.3v-6.3z" />
                    </svg>
                  </a>

                  <a
                    href="https://wa.me/31614507471"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="WhatsApp"
                  >
                    <i className="fab fa-whatsapp"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-bottom-two">
            <div className="row align-items-center justify-content-center">
              <div className="col-md-12 text-center">
                <div className="copyright-text">
                  <p>© {new Date().getFullYear()}, Vernu Stoffering Rotterdam</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterThree;
